import React, { FC, HTMLAttributes } from "react";
import { cls } from "cls";

const EmptyItem: FC<HTMLAttributes<HTMLLIElement>> = ({
  className,
  children,
}) => (
  <li
    aria-live="polite"
    className={cls(
      "box-border flex justify-center items-center w-1/4 h-26 mr-1 border border-solid rounded border-gray-200 bg-gray-200 font-bold",
      className,
    )}
  >
    {children}
  </li>
);

export default EmptyItem;
